/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Chart_Nodata2Inputs */

const en_coinvestments_insights_chart_nodata2 = /** @type {(inputs: Coinvestments_Insights_Chart_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data`)
};

/**
* | output |
* | --- |
* | "No data" |
*
* @param {Coinvestments_Insights_Chart_Nodata2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_chart_nodata2 = /** @type {((inputs?: Coinvestments_Insights_Chart_Nodata2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Chart_Nodata2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_chart_nodata2(inputs)
});
export { coinvestments_insights_chart_nodata2 as "coInvestments_insights_chart_noData" }